import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicLinkage({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M9.4 6.58a.75.75 0 11-1.06 1.06 2 2 0 00-2.72-.1l-.1.1L3.76 9.4a2 2 0 002.71 2.93l.11-.1 1.2-1.2a.75.75 0 011.13.99l-.07.07-1.2 1.2a3.5 3.5 0 01-5.08-4.8l.14-.15 1.75-1.76a3.5 3.5 0 014.95 0zm3.9-3.88a3.5 3.5 0 01.13 4.8l-.14.14-1.76 1.76a3.5 3.5 0 01-4.95 0 .75.75 0 111.06-1.06 2 2 0 002.72.1l.11-.1 1.76-1.76a2 2 0 00-2.72-2.93l-.1.1-1.2 1.2a.75.75 0 01-1.13-.98l.06-.08 1.2-1.2a3.5 3.5 0 014.95 0z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicLinkage.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicLinkage.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicLinkage svgRef={ref} {...props} />);
export default ForwardRef;
